













































import { plainToInstance } from 'class-transformer'
import { snakeCase } from 'lodash'
import { Component, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../../../Pi'
import { FieldData, SelectOptionData } from '../../../../../../../../Pi/types'
import CustomEditor from '../../../../../Editor/CustomEditor'
import { SetPropertyActionValue } from '../../../../Branching/ConditionsNode/logic/PropertyConditionValues/BaseValue'
import ConstantValue from '../../../../Branching/ConditionsNode/logic/PropertyConditionValues/ConstantValue'
import PropertyValue from '../../../../Branching/ConditionsNode/logic/PropertyConditionValues/PropertyValue'
import PropertyValueProperty
  from '../../../../Communications/Action/ui/sidebar/Actions/PropertyAction/PropertyActionValue/PropertyValueProperty.vue'
import { RunFlowNode } from '../../logic/RunFlowNode'
import ConstantTargetValue from './components/ConstantTargetValue.vue'

@Component({
  components: {
    ConstantTargetValue,
    PropertyValueProperty,
  },
  data() {
    return {
      ConstantValue,
      PropertyValue,
    }
  }
})
export default class RunFlowSidebar extends UseFields {
  @Prop() node!: RunFlowNode

  @Prop() editor!: CustomEditor

  selectedTargetType: SetPropertyActionValue | null = null

  get targetTypeOptions(): Array<SelectOptionData> {
    return [
      {
        label: this.$t(`run_flow_target_type_null_option`).toString(),
        value: null
      },
      {
        label: this.$t(`run_flow_target_type_${ snakeCase(SetPropertyActionValue.Property) }_option`).toString(),
        value: SetPropertyActionValue.Property,
      },
      {
        label: this.$t(`run_flow_target_type_${ snakeCase(SetPropertyActionValue.Constant) }_option`).toString(),
        value: SetPropertyActionValue.Constant,
      },
    ]
  }

  get flows(): Array<SelectOptionData> {
    return this.node.nodeProps.getFlows()
  }

  setFlow(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setFlow(val)
    return arg
  }

  setValueProp(index: number) {
    this.node.setPropIndex(index)
  }

  setCurrentType(arg: FieldData): FieldData {
    arg.setter = (val: SetPropertyActionValue | null) => {
      this.$set(arg.model, arg.key, val)

      if (val === SetPropertyActionValue.Property) {
        this.node.data.target = plainToInstance(PropertyValue, {
          type: SetPropertyActionValue.Property,
          property_index: null,
          transform: null
        })

        if (!this.node.mainOutput) {
          this.node.mainOutput = this.node.socketActions.createOutput().toString()
        }
      } else if (val === SetPropertyActionValue.Constant) {
        this.node.data.target = plainToInstance(ConstantValue, {
          type: SetPropertyActionValue.Constant,
          value: ''
        })

        if (!this.node.mainOutput) {
          this.node.mainOutput = this.node.socketActions.createOutput().toString()
        }
      } else {
        if (this.node.mainOutput) {
          const connection = this.node.getConnections().find(c => c.output.key === this.node.mainOutput)

          if (connection) {
            this.editor.removeConnection(connection)
          }

          this.node.socketActions.deleteOutput(+this.node.mainOutput)
          this.$delete(this.node, 'mainOutput')
        }

        this.node.data.target = null
      }
    }

    return arg
  }

  created() {
    this.selectedTargetType = this.node.data.target?.type ?? null
  }
}
